import React from "react";
import PropTypes from "prop-types";
import { CircularProgress } from "@mui/material";

const ActionButton = ({
  text,
  variant,
  onClick,
  dataCy,
  disabled,
  style,
  visible,
    loading,
  type = 'submit',
  ...rest
}) => {
  const buttonClassMap = {
    "gray-outline": "button-secondary-alt",
    "green-outline": "button-alt",
    "red-outline": "button-cancel",
    "blue-outline": "button-secondary",
    "blue-solid": "button-primary",
  };

  const buttonClass = buttonClassMap[variant] || "";

  return (
    <div
      className="fele-content fele-content-responsive"
      style={{ visibility: visible ? "visible" : "hidden" }}
    >
      <div className="button-wrapper large w-100">
              <button
                  type={type}
          data-cy={dataCy}
          className={`button ${buttonClass} text-nowrap px-5`}
          onClick={onClick}
          disabled={disabled || loading}
          style={style}
          {...rest}
        >
          {loading ? <CircularProgress color="inherit" size="24px" /> : text}
        </button>
      </div>
    </div>
  );
};

ActionButton.propTypes = {
  text: PropTypes.string,
  variant: PropTypes.string,
  onClick: PropTypes.func,
  dataCy: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  visible: PropTypes.bool,
  loading: PropTypes.bool,
};

ActionButton.defaultProps = {
  variant: "green-outline",
  visible: true,
};

export default ActionButton;
